import { render, staticRenderFns } from "./SysMessageModal.vue?vue&type=template&id=88e46504&scoped=true"
import script from "./SysMessageModal.vue?vue&type=script&lang=js"
export * from "./SysMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e46504",
  null
  
)

export default component.exports